import React, { FunctionComponent, useEffect, useState } from 'react';
import { ListGroup, Dropdown } from 'react-bootstrap';
import { connect, ConnectedProps } from 'react-redux';

import { ApplicationState } from '../../redux/States';
import { AuthDispatches, ErrorDispatches } from '../../redux/Dispatches';

import avatar1 from '../../assets/images/user/avatar-1.jpg';
import { EnchanceLink } from '../EnhanceLink';
import { getTokenExpireTime } from '../../apis/TokenStorage';

const mapState = (state: ApplicationState) => state.auth;
const mapDispatch = { ...AuthDispatches, ...ErrorDispatches };
const connector = connect(mapState, mapDispatch);

type Props = ConnectedProps<typeof connector>;

const navRight: FunctionComponent<Props> = ({
  user,
  signOut,
  changeSchool,
  catchErrorForModal,
}) => {
  if (!user) {
    return <React.Fragment></React.Fragment>;
  }
  const { schools, currentSchool, semesters, currentSemester } = user;
  const { year, sem } = semesters[currentSemester] || {};
  const [timeLeft, setTimeLeft] = useState(countDownExpireTime());
  useEffect(() => {
    const timer = setInterval(() => {
      const expireTime = countDownExpireTime();
      setTimeLeft(expireTime);
      if (expireTime.mins <= 0 && expireTime.secs <= 0) {
        signOut().catch(catchErrorForModal);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return (
    <React.Fragment>
      <div className="ml-auto">
        <span className="ml-auto">
          {year}學年度 第{sem}學期
        </span>
        <br />
        {timeLeft.mins <= 180 ? (
          <span>
            <b>
              {timeLeft.mins} 分 {timeLeft.secs} 秒
            </b>
            後自動登出
          </span>
        ) : null}
      </div>
      <ListGroup as="ul" bsPrefix=" " className="navbar-nav" id="navbar-right">
        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown
            onSelect={(e) => {
              console.log(e);
              if (e !== null) changeSchool(e).catch(catchErrorForModal);
            }}
          >
            <Dropdown.Toggle variant="link">
              {schools[currentSchool]?.name ?? ''}
            </Dropdown.Toggle>
            <Dropdown.Menu as="ul">
              {Object.entries(user.schools).map(([id, { name }]) => (
                <Dropdown.Item
                  as="li"
                  key={`school-dropdown-${id}`}
                  eventKey={id}
                >
                  <EnchanceLink to="" className="dropdown-item">
                    <i className="feather icon-settings" /> {name}
                  </EnchanceLink>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown className="drp-user">
            <Dropdown.Toggle variant="link" id="dropdown-basic">
              <i className="icon feather icon-settings" />
            </Dropdown.Toggle>
            <Dropdown.Menu className="profile-notification">
              <div className="pro-head">
                <img src={avatar1} className="img-radius" alt="User Profile" />
                <span>{user.name}</span>
              </div>
              <ListGroup
                as="ul"
                bsPrefix=" "
                variant="flush"
                className="pro-body"
              >
                <ListGroup.Item as="li" bsPrefix=" ">
                  <EnchanceLink
                    to=""
                    className="dropdown-item"
                    title="Logout"
                    onClick={() => {
                      signOut().catch(catchErrorForModal);
                    }}
                  >
                    <i className="feather icon-log-out" /> 登出
                  </EnchanceLink>
                </ListGroup.Item>
              </ListGroup>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
      </ListGroup>
    </React.Fragment>
  );
};

function countDownExpireTime(): { mins: number; secs: number } {
  const diff = (getTokenExpireTime() - Date.now()) / 1000;
  const mins = Math.floor(diff / 60);
  const secs = Math.floor(diff % 60);
  return { mins, secs };
}

export const NavRight = connector(navRight);
